import React, { PropsWithChildren, ReactNode } from "react";

import { css, cx } from "@emotion/css";

import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { Logo } from "@/uiKit/atoms/Logo.tsx";

export type BottomNavigationBarProps = PropsWithChildren<{
  userMenu: ReactNode;
  className?: string;
}>;

export const BottomNavigationBar: React.FC<BottomNavigationBarProps> = ({ userMenu, className, children }) => {
  const styles = useStyles(makeStyles);

  return (
    <nav className={cx(styles.container, className)} id="main-mobile-navbar">
      <Logo id="app-logo-mobile" className={styles.logo} />
      {children}
      {userMenu}
    </nav>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: ${theme.spacing(30)};
    width: 100%;
    z-index: ${theme.zIndex.appBar};
    border-top-width: 1px;
    border: ${theme.palette.common.white} solid;
    background-color: ${theme.palette.common.white};
    padding: ${theme.spacing(0, 8)};
    position: fixed;
    bottom: 0;
  `,
  logo: css({
    paddingTop: theme.spacing(4),
  }),
});
